import { withRouter } from 'react-router-dom';
import { CRUDform } from '@infotech/crud'
import { compose, withProps } from 'recompose'
import FormFieldsLayout from './FormFieldsLayout'

export default compose(
  withRouter,
  withProps(({ config, history }) => ({
    FormFieldsLayout,
    parentData: config,
    onCancel: history.goBack,
  })),
)(CRUDform)
